import axios from 'axios';
import { parseApiError } from '@/helpers/api-requests';

const actions = {
  async addRoleToPackage(store, {roleID, packageID}) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/packages/${packageID}/roles`,
      method: 'POST',
      data: { event_roles: [roleID] },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getPackages');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async deleteRoleFromPackage(store, {roleID, packageID}) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/packages/${packageID}/roles`,
      method: 'DELETE',
      data: { event_roles: [roleID] },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getPackages');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
};

export default actions;